import yup from '@/plugins/yup'
import { i18n } from '@/plugins/i18n'

const { t } = i18n.global

const RequestActivationTokenSchema = yup.object({
  email: yup
    .string()
    .required(t('errors.required', { label: t('views.request_activation_token.label.email') }))
    .email(t('errors.invalid', { label: t('views.request_activation_token.label.email') }))
    .label(t('views.request_activation_token.label.email')),
})

export default RequestActivationTokenSchema
